// eslint-disable-next-line no-unused-vars
import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import alignmentApi from './alignment.api';
// import togglePublishedState from '~/api/togglePublishedState.api';
import { alertSwal } from '~/utils/helpers';
import { handleThunkException } from '~/services/thunk.service';

export const fetchAlignmentApi = createAsyncThunk(
    'heroSaga/alignment/fetchAlignmentApi',
    async (navigate, { dispatch, rejectWithValue }) => {
        try {
            dispatch(requestStarted());
            const data = await alignmentApi.index();
            if (data) {
                dispatch(requestFinished());
                return data;
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            return rejectWithValue([]);
        }
    },
);

// export const toggleAlignmentPublishedStateApi = createAsyncThunk(
//     'heroSaga/alignment/toggleAlignmentPublishedStateApi',
//     async (id, { dispatch, rejectWithValue }) => {
//         try {
//             await togglePublishedState(id);

//             return id;
//         } catch (error) {
//             handleThunkException(error, dispatch);

//             return rejectWithValue();
//         }
//     },
// );

// export const createAlignmentApi = createAsyncThunk(
//     'heroSaga/alignment/createAlignmentApi',
//     async (navigate, { dispatch }) => {
//         try {
//             dispatch(requestStarted());
//             const { data } = await alignmentApi.create();

//             return data;
//         } catch (error) {
//             handleThunkException(error, dispatch, navigate);
//         } finally {
//             dispatch(requestFinished());
//         }
//     },
// );

// export const storeAlignmentApi = createAsyncThunk(
//     'heroSaga/alignment/storeAlignmentApi',
//     async (params, { dispatch, rejectWithValue }) => {
//         const { navigate, values } = params;

//         try {
//             dispatch(requestStarted());
//             const hero = await alignmentApi.store(values);
//             alertSwal('success', 'Alignment created successfully!');

//             return hero;
//         } catch (error) {
//             handleThunkException(error, dispatch, navigate);

//             return rejectWithValue([]);
//         } finally {
//             dispatch(requestFinished());
//         }
//     },
// );

export const showAlignmentApi = createAsyncThunk(
    'alignmentSaga/alignment/showAlignmentApi',
    async (params, { dispatch, rejectWithValue }) => {
        const { id, navigate } = params;

        try {
            dispatch(requestStarted());
            const { data } = await alignmentApi.show(id);

            return data;
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            return rejectWithValue();
        } finally {
            dispatch(requestFinished());
        }
    },
);

export const updateAlignmentApi = createAsyncThunk(
    'heroSaga/alignment/updateAlignmentApi',
    async (params, { dispatch, rejectWithValue }) => {
        const { navigate, id, values } = params;

        try {
            dispatch(requestStarted());
            await alignmentApi.update(id, values);
            alertSwal('success', 'Alignment updated successfully!');

            return values;
        } catch (error) {
            handleThunkException(error, dispatch, navigate);

            return rejectWithValue();
        } finally {
            dispatch(requestFinished());
        }
    },
);

// export const deleteAlignmentApi = createAsyncThunk(
//     'heroSaga/alignment/deleteAlignmentApi',
//     async (params, { dispatch }) => {
//         const { navigate, id } = params;

//         try {
//             await alignmentApi.delete(id);

//             return id;
//         } catch (error) {
//             handleThunkException(error, dispatch, navigate);
//         }
//     },
// );

export const alignmentSlice = createSlice({
    name: 'heroSaga/alignment',
    initialState: { rows: [], model: {}, editedModel: {}, pictureAttributeNames: [] }, //model is initialValues that are used for formik.
    reducers: {
        clearEditedAlignment(state) {
            state.editedModel = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAlignmentApi.fulfilled, (state, { payload }) => {
                return {
                    ...state,
                    rows: payload,
                };
            })
            .addCase(fetchAlignmentApi.rejected, (state, { payload = [] }) => {
                state.rows = payload;
            });

        // builder
        //     .addCase(toggleAlignmentPublishedStateApi.fulfilled, (state, { payload }) => {
        //         const updateRow = state.rows.find((row) => row.id === payload);
        //         updateRow.isReady = !updateRow.isReady;
        //     })
        //     .addCase(toggleAlignmentPublishedStateApi.rejected, () => {
        //         console.log('🚀 ~ rejected');
        //         //do nothing
        //     });

        // builder.addCase(createAlignmentApi.fulfilled, (state, { payload }) => {
        //     state.model = payload.model;
        // });

        // builder
        //     .addCase(storeAlignmentApi.fulfilled, (state) => {
        //         return {
        //             ...state,
        //             rows: [], //clear all rows so that api fetchAll will be called again in index page.
        //         };
        //     })
        //     .addCase(storeAlignmentApi.rejected, () => {
        //         //do nothing so that state will remain intact and component will not re-render.
        //     });

        builder
            .addCase(showAlignmentApi.fulfilled, (state, { payload }) => {
                state.editedModel = payload.model;
            })
            .addCase(showAlignmentApi.rejected, () => {
                //
            });

        builder
            .addCase(updateAlignmentApi.fulfilled, (state, { payload }) => {
                state.editedModel = payload; //this is to make Update component re-render so that the checkDuplicateName() will have the latest `initialName`.
                if (state.rows.length === 0) return;

                const updatedRow = state.rows.find((row) => row.id === payload.id);
                updatedRow.name = payload.name;
                updatedRow.description = payload.description;
                updatedRow.activeRounds = payload.activeRounds;
                updatedRow.activeTurns = payload.activeTurns;
            })
            .addCase(updateAlignmentApi.rejected, () => {
                //
            });

        // builder.addCase(deleteAlignmentApi.fulfilled, (state, { payload }) => {
        //     return {
        //         ...state,
        //         rows: state.rows.filter(({ id }) => id !== payload),
        //     };
        // });
    },
});

export const { clearEditedAlignment } = alignmentSlice.actions;
